<div class="d-flex flex-column root">
  <span class="title">{{ title }}</span>
  <div class="content flex-grow-1">
    <ng-content></ng-content>
  </div>
</div>
